module.exports = __webpack_public_path__ + "static/media/096-mozambique.7f24c329.svg";